(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('EditModalController', EditModalController)

    EditModalController.$inject = ['$uibModalInstance', 'client', 'type', 'PlanService', 'FindClientsService', 'toastr'];

    function EditModalController($uibModalInstance, client, type, PlanService, FindClientsService, toastr) {
        var vm = this;

        vm.optionsDatepicker    = { autoUpdateInput: false, singleDatePicker: true, showDropdowns: true}
        vm.client               = client;
        vm.password             = [];
        vm.type                 = type;
        vm.selectedPlan         = [];
        vm.plans                = [];
        vm.planExpires          = '';
        vm.dataClient           = {};
           
        vm.ok                   = ok;
        vm.cancel               = cancel;
        vm.getPlans             = getPlans;
        vm.submitAccount        = submitAccount;
        activate();

        function activate() {
            vm.getPlans();
            vm.planExpires = vm.client.user_plan_expires_in;
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function getPlans() {
            PlanService.getPlans().then( function(response){
                vm.plans = response.data;
            });
        }
        
        function submitAccount(type) {
            if(type === 'agents' || type === 'institutions') {
                vm.dataClient.nick       = vm.client.nick;
                vm.dataClient.id         = vm.client.id;
                vm.dataClient.password   = vm.client.password;
                vm.dataClient.email      = vm.client.users_email;
                vm.dataClient.plan       = vm.selectedPlan;
                //if(typeof vm.client.users.plans[0] !== 'undefined')
                vm.dataClient.expires_in = vm.planExpires;
            } else {
                vm.dataClient.nick       = vm.client.nick;
                vm.dataClient.id         = vm.client.users_id;
                vm.dataClient.password   = vm.client.password;
                vm.dataClient.email      = vm.client.users_email;
            }

            FindClientsService.edit(vm.dataClient).then( function(response){
                toastr.success('Successfully edited!');
                if(typeof vm.selectedPlan !== 'undefined'){
                    vm.plan = vm.selectedPlan.friendly_name;
                    vm.client.friendly_name = vm.selectedPlan.friendly_name;
                }
                if(typeof vm.planExpires !== 'undefined' || vm.planExpires !== '') {
                    vm.client.user_plan_expires_in = vm.planExpires.format('YYYY-MM-DD');
                }
                vm.password = '';
            });
        }
    }
})();